var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVscodeJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5588 4.31597L30.3221 0.349835C29.3696 -0.109238 28.2297 0.0843849 27.4818 0.832329L0.518294 25.4161C-0.206228 26.0782 -0.206228 27.2196 0.519856 27.8801L2.72153 29.8819C3.31489 30.4222 4.20961 30.4612 4.84825 29.9772L37.319 5.34498C38.4089 4.51896 39.9735 5.29501 39.9735 6.66286V6.56761C39.9735 5.60731 39.4239 4.73132 38.5588 4.31597Z",
    fill: "#0065A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5588 35.6578L30.3221 39.624C29.3696 40.083 28.2297 39.8894 27.4818 39.1415L0.518294 14.5577C-0.206228 13.8972 -0.206228 12.7542 0.519856 12.0952L2.72153 10.0934C3.31489 9.55315 4.20961 9.51412 4.84825 9.99817L37.319 34.6288C38.4089 35.4548 39.9735 34.6788 39.9735 33.3109V33.4062C39.9735 34.3665 39.4239 35.2425 38.5588 35.6578Z",
    fill: "#007ACC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3238 39.624C29.3698 40.083 28.2314 39.8894 27.4819 39.1399C28.4032 40.0612 29.9803 39.4085 29.9803 38.1046V1.86759C29.9803 0.563759 28.4032 -0.0889359 27.4819 0.832332C28.2299 0.0843874 29.3698 -0.109235 30.3238 0.348276L38.559 4.30817C39.4241 4.72508 39.9753 5.5995 39.9753 6.55981V33.4124C39.9753 34.3727 39.4256 35.2471 38.559 35.6641L30.3238 39.624Z",
    fill: "#1F9CF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3218 39.7005C28.9511 39.9456 29.6694 39.93 30.3049 39.6239L38.5354 35.6641C39.4005 35.2487 39.9501 34.3727 39.9501 33.4124V6.56136C39.9501 5.60106 39.4005 4.72664 38.5354 4.30972L30.3049 0.349834C29.4711 -0.0514636 28.4952 0.046909 27.7628 0.579371C27.6582 0.655883 27.5583 0.740202 27.4646 0.83389L11.7094 15.2072L4.84669 9.9966C4.20805 9.51098 3.31489 9.55158 2.72153 10.0918L0.519856 12.0937C-0.206228 12.7542 -0.206228 13.8956 0.518294 14.5577L6.47062 19.9869L0.518294 25.4161C-0.206228 26.0782 -0.206228 27.2196 0.519856 27.8801L2.72153 29.8819C3.31489 30.4222 4.20805 30.4612 4.84669 29.9772L11.7094 24.7681L27.4646 39.1415C27.7144 39.3897 28.0064 39.5787 28.3218 39.7005ZM29.9614 10.9132L18.0068 19.9869L29.9614 29.0622V10.9132Z",
    fill: "url(#paint0_linear_4_3)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_3",
    x1: 19.9623,
    y1: 0.103122,
    x2: 19.9623,
    y2: 39.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeJob);
export default __webpack_public_path__ + "static/media/vscode-job.0d1809a4d5cd945b8e495fa4aa6616d3.svg";
export { ForwardRef as ReactComponent };